<template>
  <div class="customerLogo">
      <a :href="imgdata.url" target="_blank">
        <img :src="imgdata.logo"/>
      </a>
  </div>
</template>
<script>
/**
 * 服务客户单个logo组件
 *
 * @requires Customer.vue
 * @author liguojie
 */
export default {
  props: [
    'imgdata'// 传入值包含url跳转企业网址，logo图片url
  ],
  components: {
  },
  name: 'CustomerLogo',
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.customerLogo{
    width: 170px;
    height: 70px;
    line-height: 70px;
    box-sizing: border-box;
    border: 1px solid #E2E2E8;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    a{
        width: 170px;
        height: 70px;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
            width: 129px;
            height: 48px;
        }
    }
}
</style>
